import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Category } from '../router/category';
import { selectAllVppApplications } from '../vpp-applications/vpp-applications.selector';
import * as fromApplicationsConfiguredSettings from './applications-configured-settings.reducer';
import {
  ApplicationConfiguredSetting,
  ApplicationsConfiguredSettingsState,
} from './applications-configured-settings.state';

export const selectApplicationsConfiguredSettingsState = createFeatureSelector<ApplicationsConfiguredSettingsState>(
  'applicationsConfiguredSettings'
);

export const selectApplicationsConfiguredSettingsIds = createSelector(
  selectApplicationsConfiguredSettingsState,
  fromApplicationsConfiguredSettings.selectApplicationsConfiguredSettingsIds
);

export const selectApplicationsConfiguredSettingsEntities = createSelector(
  selectApplicationsConfiguredSettingsState,
  fromApplicationsConfiguredSettings.selectApplicationsConfiguredSettingsEntities
);

export const selectAllApplicationsConfiguredSettings = createSelector(
  selectApplicationsConfiguredSettingsState,
  fromApplicationsConfiguredSettings.selectAllApplicationsConfiguredSettings
);

export const selectApplicationsConfiguredSettingsForCategory = (category: Category) =>
  createSelector(
    selectAllApplicationsConfiguredSettings,
    selectAllVppApplications,
    (settings: ApplicationConfiguredSetting[], vppApps) => {
      if (!category || !settings) {
        return [];
      }

      // Walk the category hierarchy bottom-up, collecting unique bundle identifiers.
      // Most specific (deepest) category wins when the same bundle appears at multiple levels.
      const unique = new Map<string, ApplicationConfiguredSetting>();

      const processCategory = (current: Category) => {
        settings
          .filter((setting) => setting.categoryId === current.categoryId)
          .forEach((setting) => {
            if (!unique.has(setting.bundleIdentifier)) {
              unique.set(setting.bundleIdentifier, setting);
            }
          });

        if (current.parent) {
          processCategory(current.parent);
        }
      };

      processCategory(category);

      // Map VPP applications to retrieve the display name for VPP applications.
      const vppByAdamId = new Map(vppApps.map((vpp) => [vpp.adamIdStr, vpp]));
      return Array.from(unique.values()).map((setting) => {
        const vpp = setting.adamIdStr ? vppByAdamId.get(setting.adamIdStr) : null;

        return {
          ...setting,
          displayName: vpp?.name ?? setting.displayName,
        };
      });
    }
  );
